module.exports = __webpack_public_path__ + "static/media/logo.f0b0404b.svg";